import { BaseModel } from "../base.model"; 

export interface MenuList extends BaseModel {
    parent?: any;
    module?: any;
    actions?: any;
}

export const defaultMenuList: Readonly<MenuList> = {};